import React from 'react'
import Footer from '../Footer'
import RogerSeven from '../RogerSeven'

function Roger7() {
    window.scrollTo(0,0);
    return (
        <div>
            <RogerSeven/>
            <Footer/>
        </div>
    )
}

export default Roger7
